import styled from 'styled-components';
import { Text as P } from 'styles/elements/text';

const Text = styled(P)`
  color: ${props => props.theme.fontColorPrimary};
  margin-bottom: 38px;
  font-size: ${props => props.theme.fontSizeLarge};
  font-family: ${props => props.theme.fontFamilyLight};
`;

export default Text;
